// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.criteria.RentalManagerUserPropertyCriteriaV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { UserPropertyCriteriaSetV2RequestDto } from '../..';

export const RentalManagerUserPropertyCriteriaV2WebApiHandler_set_Path = '/api/web/v2/users/properties/criteria/set';

/**
 * Set criteria for a listing
 */
export const RentalManagerUserPropertyCriteriaV2WebApiHandler_set = (
  postData: UserPropertyCriteriaSetV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyCriteriaSetV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyCriteriaV2WebApiHandler_set_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
